import { apiEndpoints } from '@constants';
import { client } from '@utils';

const submitLogin = data => (
  client.unauthorized.post(apiEndpoints.login, data)
);

const createCategory = data => (
  client.authorized.post(apiEndpoints.category, data)
);

const editCategory = data => (
  client.authorized.put(apiEndpoints.category, data)
);

const deleteCategory = data => (
  client.authorized.delete(apiEndpoints.category, {
    data,
  })
);

const createSubcategory = data => (
  client.authorized.post(apiEndpoints.subcategoryCreate, data)
);

const submitCategoriesOrder = data => (
  client.authorized.put(apiEndpoints.categoryOrder, data)
);

const createItem = data => (
  client.authorized.post(apiEndpoints.item, data)
);

const editItem = data => (
  client.authorized.put(apiEndpoints.item, data)
);

const deleteItem = data => (
  client.authorized.delete(apiEndpoints.item, {
    data,
  })
);

const createSize = data => (
  client.authorized.post(apiEndpoints.size, data)
);

const editSize = data => (
  client.authorized.put(apiEndpoints.size, data)
);

const deleteSize = data => (
  client.authorized.delete(apiEndpoints.size, {
    data,
  })
);

const applyOptionToSize = data => (
  client.authorized.post(apiEndpoints.optionToSize, data)
);

const detachOptionFromSize = data => (
  client.authorized.delete(apiEndpoints.optionToSize, { data })
);

const createOption = data => (
  client.authorized.post(apiEndpoints.option, data)
);

const editOption = data => (
  client.authorized.put(apiEndpoints.option, data)
);

const deleteOption = data => (
  client.authorized.delete(apiEndpoints.option, {
    data,
  })
);

const createValue = data => (
  client.authorized.post(apiEndpoints.optionValue, data)
);

const editValue = data => (
  client.authorized.put(apiEndpoints.optionValue, data)
);

const deleteValue = data => (
  client.authorized.delete(apiEndpoints.optionValue, {
    data,
  })
);

const applyAvailabilityToItem = data => (
  client.authorized.put(apiEndpoints.availabilityToItem, data)
);

const applyAvailabilityToCategory = data => (
  client.authorized.put(apiEndpoints.availabilityToCategory, data)
);

const applyAvailabilityToSpecialSize = data => (
  client.authorized.put(apiEndpoints.availabilityToSpecialSize, data)
);

const applyAvailabilityToSpecialCategory = data => (
  client.authorized.put(apiEndpoints.availabilityToSpecialCategory, data)
);

const detachAvailabilityFromItem = data => (
  client.authorized.delete(apiEndpoints.availabilityToItem, {
    data,
  })
);

const detachAvailabilityFromCategory = data => (
  client.authorized.delete(apiEndpoints.availabilityToCategory, {
    data,
  })
);

const deleteAvailability = data => (
  client.authorized.delete(apiEndpoints.availability, {
    data,
  })
);

const createAvailabilityForCategory = data => (
  client.authorized.post(apiEndpoints.availabilityToCategory, data)
);

const createAvailabilityForItem = data => (
  client.authorized.post(apiEndpoints.availabilityToItem, data)
);

const createAvailabilityForSpecialCategory = data => (
  client.authorized.post(apiEndpoints.availabilityToSpecialCategory, data)
);

const createAvailabilityForSpecialSize = data => (
  client.authorized.post(apiEndpoints.availabilityToSpecialSize, data)
);

const editAvailability = data => (
  client.authorized.put(apiEndpoints.availability, data)
);

const createSpecialCategory = data => (
  client.authorized.post(apiEndpoints.specialCategory, data)
);

const editSpecialCategory = data => (
  client.authorized.put(apiEndpoints.specialCategory, data)
);

const deleteSpecialCategory = data => (
  client.authorized.delete(apiEndpoints.specialCategory, {
    data,
  })
);

const createSpecialSize = data => (
  client.authorized.post(apiEndpoints.specialSize, data)
);

const editSpecialSize = data => (
  client.authorized.put(apiEndpoints.specialSize, data)
);

const deleteSpecialSize = data => (
  client.authorized.delete(apiEndpoints.specialSize, {
    data,
  })
);

const detachAvailabilityFromSpecialCategory = data => (
  client.authorized.delete(apiEndpoints.availabilityToSpecialCategory, {
    data,
  })
);

const detachAvailabilityFromSpecialSize = data => (
  client.authorized.delete(apiEndpoints.availabilityToSpecialSize, {
    data,
  })
);

export {
  applyAvailabilityToSpecialSize,
  applyAvailabilityToSpecialCategory,
  createAvailabilityForSpecialCategory,
  createAvailabilityForSpecialSize,
  detachAvailabilityFromSpecialSize,
  detachAvailabilityFromSpecialCategory,
  deleteSpecialSize,
  deleteSpecialCategory,
  editSpecialSize,
  createSpecialSize,
  editSpecialCategory,
  createSpecialCategory,
  createAvailabilityForCategory,
  createAvailabilityForItem,
  editAvailability,
  deleteAvailability,
  detachAvailabilityFromItem,
  detachAvailabilityFromCategory,
  applyAvailabilityToItem,
  applyAvailabilityToCategory,
  submitLogin,
  editCategory,
  deleteCategory,
  createSubcategory,
  createCategory,
  submitCategoriesOrder,
  createItem,
  editItem,
  deleteItem,
  createSize,
  editSize,
  deleteSize,
  applyOptionToSize,
  detachOptionFromSize,
  createOption,
  editOption,
  deleteOption,
  createValue,
  editValue,
  deleteValue,
};
